/**
 * Setting drawing correction with brush
 * @2023/11/14
 *
 * @log add cache to rememver last setting
 */

import { useState, ChangeEvent } from 'react';

import {
  getBrushCorrectSetting as init,
  cacheBrushCorrectSetting as cache,
} from '../state';
import { TKEvent, TKSystem } from '../types';

export const useBrushCorrectSetting = (systems: TKSystem[]) => {
  // initialize brush correction settings from cache:
  const BCS = init();

  // symbol type: DUCT | PIPE | PLUMBING, Default is DUCT
  const [categoryType, setCategoryType] = useState(BCS.categoryType);
  // selected system
  const [selectedSystem, setSelectedSystem] = useState<string>(
    BCS.selectedSystem,
  );
  // selected color
  const [renderColor, setRenderColor] = useState(BCS.renderColor);
  // set zone property
  const [zoneProperty, setZoneProperty] = useState(BCS.zoneProperty);

  // brush type
  const [brushType, setBrushType] = useState(BCS.brushType);

  // systems by category
  const systemsByCategory = systems.filter(
    (sys) => sys.category === categoryType,
  );

  // cache new settings every rendering
  cache({
    categoryType,
    selectedSystem,
    renderColor,
    zoneProperty,
  });

  // actually set category type!
  const categoryChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setCategoryType(event.target.value);
  };

  const systemChangeHandler = (system: string) => {
    setSelectedSystem(system);
  };

  const zoneChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const zoneValue = event.target.value;
    setZoneProperty(zoneValue);
  };

  const colorTypeChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setRenderColor(event.target.value);
  };

  const brushTypeChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setBrushType(event.target.value);
  };

  const applyBrushSelectHandler = () => {
    const detail = {
      categoryType,
      selectedSystem,
      renderColor,
      zoneProperty,
      brushType,
    };
    document.dispatchEvent(
      new CustomEvent(TKEvent.APPLY_BRUSH_SETTING, { detail }),
    );
  };

  return {
    categoryType,
    selectedSystem,
    renderColor,
    systemsByCategory,
    zoneProperty,
    brushType,
    brushTypeChangeHandler,
    zoneChangeHandler,
    categoryChangeHandler,
    systemChangeHandler,
    colorTypeChangeHandler,
    applyBrushSelectHandler,
  };
};
